if (!customElements.get('cart-note')) {
  class CartNote extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.note = this.querySelector('textarea');
      this.button = this.querySelector('[data-save-note]');
      this.status = this.querySelector('[data-note-status]');

      if (!this.note || !this.button || !this.status) return;

      this.initialized = true;
      this.savedValue = this.note.value;
      this.saving = false;

      this.note.addEventListener('input', () => {
        if (!this.saving) {
          this.status.textContent =
            this.note.value === this.savedValue
              ? ''
              : 'Tienes cambios sin guardar.';
        }
      });

      this.button.addEventListener('click', () => this.save());
    }

    async save() {
      if (this.saving) return;

      const value = this.note.value;
      const updateUrl = this.dataset.updateUrl;

      if (!updateUrl) {
        this.status.textContent =
          'No se ha podido guardar. Recarga la página e inténtalo de nuevo.';
        return;
      }

      this.saving = true;
      this.button.disabled = true;
      this.status.textContent = 'Guardando…';

      try {
        const url = new URL(updateUrl, window.location.origin);

        if (!url.pathname.endsWith('.js')) {
          url.pathname += '.js';
        }

        const response = await fetch(url.toString(), {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ note: value })
        });

        if (!response.ok) {
          throw new Error('Error al guardar');
        }

        const cart = await response.json();

        if ((cart.note || '') !== value) {
          throw new Error('La nota no coincide');
        }

        this.savedValue = value;

        this.status.textContent =
          this.note.value === value
            ? 'Observaciones guardadas.'
            : 'Tienes nuevos cambios sin guardar. Pulsa Guardar de nuevo.';
      } catch (error) {
        this.status.textContent =
          'No se han podido guardar. Vuelve a pulsar Guardar.';
      } finally {
        this.saving = false;
        this.button.disabled = false;
      }
    }
  }

  customElements.define('cart-note', CartNote);
}